import Styled from "styled-components";

const HowtouseWrap = Styled.div`
.spacing{
   marginTop:"20px"
}
.success-section {
  /* padding: 60px 20px; */
  text-align: center;
}

.section-title {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 40px;
}

.success-row {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.col {
  flex: 1;
  min-width: 220px;
}

.success-card {
  background: #ffffff;
  padding: 30px 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.success-card h3 {
  font-size: 32px;
  color: #1b5e20;
  margin-bottom: 8px;
}

.success-card p {
  font-size: 20px;
  color: #555;
}

.sub-head{
   font-size:32px;
   font-weight:500 !important;
}

.steps-contain{
   padding-top:10%;
   padding-bottom:10%;
   }

.content{
   animation: fadeImg 5s ease-in-out 
}

.text-list{
   font-family: "DM Sans", sans-serif !important;
   font-size: 18px;
   font-weight:400;
   
}

img {
    max-width: 90%;
    height: auto;
}


   @keyframes fadeTop {
      from {
        opacity: 0;
        transform: translateY(-70px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    .fade-top {
      animation: fadeTop 4s ease forwards;
    }

 @media  (max-width: 768px) {
   .theme-heading{
      font-size: 24px !important;
   }

   .sub-head{
      font-size:20px !important;
   font-weight:500 !important;
   }

   p{
      font-size: 16px !important;
      font-weight:400 !important;
   }

   img{
    max-width: 50%;
    height: auto;
}
 }

 

 @keyframes fadeImg {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`;

export default HowtouseWrap;
